import { render } from "./TheBankAccountFormPage.vue?vue&type=template&id=39b4a942"
import script from "./TheBankAccountFormPage.vue?vue&type=script&lang=js"
export * from "./TheBankAccountFormPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__